import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

function ProviderVerification() {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null); // 'success', 'error', 'pending'
  const [message, setMessage] = useState('');
  
  const token = searchParams.get('token');
  const API_URL = process.env.REACT_APP_API_URL || 'https://uat.lemmontags.com';

  const handleDecision = async (accion) => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/proveedores/verificar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token, accion })
      });

      const data = await response.json();
      
      if (response.ok) {
        setStatus('success');
        setMessage(accion === 'aceptar' 
          ? '¡Verificación exitosa! Ahora recibirás recordatorios sobre los servicios.'
          : 'Has rechazado la invitación. No recibirás más correos.');
      } else {
        setStatus('error');
        setMessage(data.error || 'Error al procesar la solicitud');
      }
    } catch (error) {
      setStatus('error');
      setMessage('Error de conexión. Por favor intenta nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <div style={errorIconStyle}>⚠️</div>
          <h2>Token Inválido</h2>
          <p>El enlace de verificación no es válido o ha expirado.</p>
        </div>
      </div>
    );
  }

  if (status === 'success') {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <div style={successIconStyle}>✓</div>
          <h2>¡Proceso Completado!</h2>
          <p>{message}</p>
          <p style={{ fontSize: '14px', color: '#999', marginTop: '20px' }}>
            Puedes cerrar esta ventana
          </p>
        </div>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <div style={errorIconStyle}>⚠️</div>
          <h2>Error</h2>
          <p>{message}</p>
          <button 
            style={buttonStyle} 
            onClick={() => window.location.reload()}
          >
            Intentar Nuevamente
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <h1 style={{ color: '#333', marginBottom: '10px' }}>
          Invitación de Proveedor
        </h1>
        <h2 style={{ color: '#667eea', marginBottom: '30px' }}>
          LemmonTags
        </h2>
        
        <div style={infoBoxStyle}>
          <p>Has sido invitado como proveedor de servicios.</p>
          <p>Al aceptar esta invitación:</p>
          <ul style={{ textAlign: 'left', margin: '15px 0' }}>
            <li>Recibirás recordatorios automáticos sobre servicios</li>
            <li>No necesitas crear cuenta ni contraseña</li>
            <li>Es completamente gratuito</li>
            <li>Puedes cancelar en cualquier momento</li>
          </ul>
        </div>

        <div style={{ marginTop: '30px' }}>
          <button
            style={{ ...buttonStyle, ...acceptButtonStyle }}
            onClick={() => handleDecision('aceptar')}
            disabled={loading}
          >
            {loading ? 'Procesando...' : 'Aceptar Invitación'}
          </button>
          
          <button
            style={{ ...buttonStyle, ...rejectButtonStyle }}
            onClick={() => handleDecision('rechazar')}
            disabled={loading}
          >
            Rechazar
          </button>
        </div>

        <p style={{ fontSize: '12px', color: '#999', marginTop: '30px' }}>
          Si no esperabas esta invitación, simplemente ignora este correo.
        </p>
      </div>
    </div>
  );
}

// Estilos
const containerStyle = {
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: 0,
  padding: '20px'
};

const cardStyle = {
  background: 'white',
  borderRadius: '16px',
  boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
  padding: '40px',
  maxWidth: '500px',
  width: '100%',
  textAlign: 'center'
};

const buttonStyle = {
  padding: '12px 30px',
  borderRadius: '8px',
  fontSize: '16px',
  fontWeight: 'bold',
  cursor: 'pointer',
  border: 'none',
  margin: '10px',
  transition: 'all 0.3s'
};

const acceptButtonStyle = {
  background: '#10b981',
  color: 'white'
};

const rejectButtonStyle = {
  background: 'white',
  color: '#ef4444',
  border: '2px solid #ef4444'
};

const infoBoxStyle = {
  background: '#f3f4f6',
  borderRadius: '8px',
  padding: '20px',
  margin: '20px 0'
};

const successIconStyle = {
  width: '80px',
  height: '80px',
  background: '#10b981',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto 20px',
  fontSize: '40px',
  color: 'white'
};

const errorIconStyle = {
  fontSize: '48px',
  marginBottom: '20px'
};

export default ProviderVerification;